import React from "react";
import Flex from "../Flex";
import { Label } from "../Typography";
import { TToggleSize } from "./helpers";
import * as S from "./styled";

export type TToggleProps = {
    checked: boolean;
    label?: React.ReactNode;
    helperText?: React.ReactNode;
    disabled?: boolean;
    trackName: string;
    trackData?: Record<string, unknown>;
    onChange: (value: boolean) => void;
    size?: TToggleSize;
};

const Toggle: React.FC<TToggleProps> = ({ disabled = false, checked, label, helperText, onChange, size = "sm" }) => {
    const handleChange: React.ChangeEventHandler<HTMLInputElement> = () => {
        onChange(!checked);
    };

    return (
        <S.Wrapper $disabled={disabled} $checked={checked} $size={size}>
            <S.HiddenInput type="checkbox" checked={checked} onChange={handleChange} disabled={disabled} />
            <S.Slider $checked={checked} />
            {(label || helperText) && (
                <Flex direction="column" gap="2px">
                    {label && (
                        <Label
                            size={size === "sm" ? "label-small-medium" : "label-regular-medium"}
                            color="text-primary-1200"
                        >
                            {label}
                        </Label>
                    )}
                    {helperText && (
                        <Label
                            size={size === "sm" ? "label-small-regular" : "label-regular-regular"}
                            color="text-primary-700"
                        >
                            {helperText}
                        </Label>
                    )}
                </Flex>
            )}
        </S.Wrapper>
    );
};

export default Toggle;
